let endpoints = {
    backendHost: window.env['APP_DOMAIN'],
    environment: 'development'
};


export const EndPoints = endpoints;